export default __webpack_public_path__ + "static/media/icons8-zalo.4740aacb.svg";